import React, {createContext, Component} from 'react';
import Header from "../framework/Header";
import Footer from "../framework/Footer";
import webRootContext from "../components/webrootcontext/WebRootContext";
import { USER_OBJECT } from "../components/UserObject";

export const UserProfile = createContext();


class UserProfileProvider extends Component {
    
    state = {
        userProfile: USER_OBJECT 
    };
    //{ "userId": "", "firstName": "", "lastName": "", "email": "", "authenticated": false}
    
    
    componentDidMount() {
        
		let userProfileURL = webRootContext + "/rest/usermanagement/get/userProfile";

        fetch(userProfileURL, {mode:"no-cors"})
          .then((response) => response.json())
          .then( (data) => {
            data.authenticated = true;
            this.setState({
              userProfile: data
            });
            
           sessionStorage.setItem("isLoggedIn", true);
            
          }, (error) => {
       		  // If there is an error set the userProfile to empty
           	  sessionStorage.setItem("isLoggedIn", false);
              this.setState({
                 userProfile: USER_OBJECT
              });
              console.log("Error getting profile:", error);
          });      
          
          return sessionStorage.setItem("userRole", "user");

    }
    
    render() {
        let userProperlyProvisioned = this.state.userProfile.properlyProvisionedUser === true;
        // Hard coded the following 2023/04/19 to force proper provisioned
        userProperlyProvisioned = true;
        // Some temp CSS should be moved to common.
        // TODO: Make components so you don't need UserProfile
        let appCSS = "BCHApp";
        let containerCSS = "container";
        const tempStyle = {
            margin: "20px",
        }
        if (userProperlyProvisioned) {
          // Original code (assumed user was properly provisioned)
          return (
          <UserProfile.Provider value={{...this.state}}>
            {this.props.children}
          </UserProfile.Provider>
          )
        } else {
			// User is NOT properly provisioned.
            return (
                <div className={appCSS}>
					<Header
			            longTitle="Observership"
			            shortTitle="Observership"
			            handleMouseUp={false}
			            userName="Unauthorized User"
			            buttonLabel={"log out"}
			            buttonAction={(e) => console.log("nothing")}
			          />
			          <article style={tempStyle}>
			          	<div className={containerCSS}>
			          		<h1 style={{color: "#cc0000"}}>Error - User is not properly provisioned</h1>
					  		<p>This page needs to be reformatted for properly layout</p>
					  	</div>
					  </article>
					<Footer/>
				</div>
                )
        }
    }    
}

export default UserProfileProvider;

